<div class="flex h-[calc(100vh-84px)]">
	<div class="m-auto flex flex-col justify-center items-center">
		<img src="./assets/img/aeocloud_logo.svg" class="h-20 mb-8" alt="AeoCloud Logo" />
		<h2 class="text-5xl font-semibold mb-4">Welcome to AeoCloud</h2>
		<p class="text-slate-400 w-1/2 text-center mb-4">
			A cloud-native platform to manage SmartThings hubs and locations, automate rules, and generate powerful insights from sensor
			data — all in one sleek, connected experience.
		</p>
		<div class="flex felx-row justify-center items-center gap-4">
			<p-button routerLink="/properties/add">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				<span>Add Property</span>
			</p-button>
		</div>
	</div>
</div>
